<template>
  <div class="box-collaborator__container">
    <div
      class="flex box-collaborator h-9 is-treatment-share-v2"
    >
      <ul :class="`flex box-${list.length}`">
        <li
          v-for="(collaborator, index) in list.slice(0, 3)"
          :key="collaborator.userId"
          v-tooltip="collaboratorTooltip(collaborator, index)"
          class="presenter-avatar"
        >
          <aha-avatar
            :name="collaborator.name"
            :image="collaborator.avatar"
            :id="collaborator.id"
            class="avatar"
          />
        </li>
        <li
          class="li-more"
          @click="$emit('openShareToEditPopup')"
          v-tooltip="tooltipInvite"
          v-if="inviteToEditVisible"
        >
          <div class="cursor-pointer presenter-avatar relative more">
            + <span v-if="list.length > 3">{{ list.length - 3 }}</span>
          </div>

          <OnboardingPresentingRight v-if="isShowOnboardPresentingRight" @hide="isShowOnboardPresentingRight = false" />
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import constants from '@/constant'
import OnboardingPresentingRight from '@/components-v2/common/onboarding-presenting-right/OnboardingPresentingRight'
import Util from '@/util'

export default {
  components: {
    OnboardingPresentingRight,
  },
  props: {
    list: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      isShowOnboardPresentingRight: false,
    }
  },

  computed: {
    ...mapState({
      currentUser: (state) => state.currentUser,
      workingMode: (state) => state.workingMode,
      presentation: (state) => state.presentation,
      userOnlineByPresentationId: (state) => state.userOnlineByPresentationId,
    }),
    ...mapGetters(['isEnableUserPresentingRight']),
    inviteToEditVisible() {
      return this.currentUser.identifyProvider !== 'skoletube'
    },

    tooltipInvite() {
      if (this.isShowOnboardPresentingRight) return ''
      return 'Add Editors'
    },
  },

  created() {
    this.isShowOnboardPresentingRight = this.checkShowOnboardPresentingRight()
  },

  methods: {
    checkShowOnboardPresentingRight() {
      try {
        if (this.isEnableUserPresentingRight && this.currentUser.id === this.presentation.User.id &&
          !window.localStorage.getItem('hideOnboardingPresentingRight') && this.presentation.slides.length > 1) {
          window.localStorage.setItem('hideOnboardingPresentingRight', true)

          Util.mixpanelTracking(
            'Presentation Editor',
            'Presenting right > Feature onboarding pop-up > Show',
            null,
            null,
            {
              presentationId: this.presentation.id,
              userId: this.currentUser.id,
              plan: this.currentUser.plan,
            },
          )
          return true
        }
      } catch (error) {
        // do nothing
      }
      return false
    },
    collaboratorTooltip(collaborator) {
      let role = this.$i18nPresenter.t('Editor')
      if (collaborator.accountRole ===
          constants.workspace.VIEWER && this.workingMode === constants.workspace.TEAM) {
        role = this.$i18nPresenter.t('Viewer')
      }
      let textForMyData = ''
      if (collaborator.isMyData) {
        textForMyData = this.$i18nPresenter.t('(you)')
      }
      return `<div class="text-center"><strong>${collaborator.name}</strong> ${textForMyData} </br> ${role}<div>`
    },
  },
}
</script>

<style lang="scss" scoped>
.box-collaborator {
  &:not(.is-treatment-share-v2) {
    @apply bg-secondary-15;
  }
  border-radius: 19px;
  padding: 4px;

  .li-more {
    z-index: 1;
  }

  .presenter-avatar {
    @apply w-7 h-7 rounded-full text-center;
    line-height: 26px;
    margin-right: -5px;

    .avatar {
      border: 1px solid #FFFFFF;
      font-size: 10px;
      font-weight: bold;
    }

    &:nth-child(1) {
      z-index: 4;
    }

    &:nth-child(2) {
      z-index: 3;
    }

    &:nth-child(3) {
      z-index: 2;
    }

    &:nth-child(4) {
      z-index: 1;
    }

    &:last-child {
      margin-right: 5px;
    }

    &.more {
      @apply text-base-0;
      font-weight: bold;
      background-color: #E2E5EE;
      color: #000;
      cursor: pointer;

      &:hover {
        background-color: #348EF6;
        color: #fff;
      }
    }
  }
}

.share-button-desktop {
  @apply bg-base-0 hover:bg-secondary-10 outline-none;
  @apply h-7 px-1 inline-block font-bold cursor-pointer whitespace-nowrap transition-colors;
  border-radius: 14px;
  padding: 4px;

  .icon-invite {
    position: relative;
    top: -2px;
  }
}

.share-button-mobile {
  display: none;
}

@media (max-width: 1024px) {
  .box-collaborator {
    display: none;
  }

  .share-button-mobile {
    display: block;
    margin-right: 8px;
    margin-top: -2px;

    &::v-deep button {
      min-width: 1.2rem;
      height: 28px;
    }
  }
}
</style>
